import {getField, updateField} from 'vuex-map-fields';

export default {
    modules: {
        StoreFileHistory: {
            namespaced: true,
            state: {
                itemList: [],
                searchTerm: null,
                searchTermFile: null,
                selectedItemList: [],
                options: {
                    page: 1,
                    itemsPerPage: 20,
                    sortBy: ['history_date'],
                    sortDesc: [true],
                    multiSort: false,
                    mustSort: true,
                    descending: false,

                },
                totalRecords: 0,
                loading: false,
                restoreLoading: false,
                // columns: [
                //     {text: '', value: 'actions', sortable: false, divider: true, width: 80, brief: true,},
                //     {text: 'History date', value: 'history_date', sortable: true, divider: true, width: 80, brief: true,},
                //     {text: 'History user', value: 'history_username', sortable: true, divider: true, width: 80, brief: true,},
                //     // {text: 'Сhanged fields', value: 'changed_fields', sortable: false, divider: true, width: 200, brief: true,},
                //     // {text: 'History m2m', value: 'history_m2m', sortable: false, divider: true, width: 200, brief: true,},
                //     {text: 'Alive', value: 'alive', sortable: true, filterable: true, divider: true, brief: true,},
                //     {text: 'Angebot ID (Title)', value: 'title', sortable: true, filterable: true, divider: true, brief: true,},
                //     {text: 'Baugruppe (Variants)', value: 'variants', sortable: false, filterable: true, divider: true, brief: true,},
                //     {text: 'Kunde (Customer)', value: 'customer__title', sortable: true, divider: true, brief: true,},
                //     // {text: 'Customer type', value: 'customer__customer_type', sortable: true, divider: true},
                //     // {text: 'Customer priority', value: 'customer__priority', sortable: true, divider: true},
                //     {text: 'Kunden-Aufträge (Customer order)', value: 'customer_order__title', sortable: true, divider: true, brief: true,},
                //     {text: 'Bearbeiter (Editors)', value: 'editors', sortable: false, divider: true, brief: true,},
                //     {text: 'Express', value: 'express', sortable: true, divider: true},
                //     {text: 'Status', value: 'status', sortable: true, divider: true},
                //     {text: 'Eingangsdatum (Date receipt)', value: 'date_receipt', sortable: true, divider: true},
                //     {text: 'Ziel Abgabe (Target levy)', value: 'target_levy', sortable: true, divider: true},
                //     {text: 'Abgabedatum (Submission date)', value: 'submission_date', sortable: true, divider: true},
                //     {text: 'Eingang bestätigt (Receipt confirmed)', value: 'receipt_confirmed', sortable: true, divider: true},
                //     {text: 'Daten gespeichert (Data saved)', value: 'data_saved', sortable: true, divider: true},
                //     {text: 'Assembly variant', value: 'assembly_variant', sortable: true, divider: true},
                //     {text: 'Total variations', value: 'total_variations', sortable: true, divider: true},
                //     {text: 'Losgröße (Lot size)', value: 'lot_size', sortable: true, divider: true},
                //     {text: 'Mat-Faktor (Food factor)', value: 'food_factor', sortable: true, divider: true},
                //     {text: 'Gesamtpreise (Total prices)', value: 'total_prices', sortable: true, divider: true},
                //     {text: 'Material', value: 'material', sortable: true, divider: true},
                //     {text: 'LP Einkauf (LP purchasing)', value: 'lp_purchasing', sortable: true, divider: true},
                //     {text: 'EMS', value: 'ems', sortable: true, divider: true},
                //     {text: 'Hinweis (note)', value: 'note', sortable: true, divider: true},
                //     {text: 'Richtpreis (Guide price)', value: 'guide_price', sortable: true, divider: true},
                //     {text: 'Typ (Type)', value: 'typ', sortable: true, divider: true},
                //     {text: 'Erstellt am (Created on)', value: 'created_on', sortable: true, divider: true},
                //     {text: 'Letzter Bearbeiter (Last editor)', value: 'last_editor__username', sortable: true, divider: true},
                //     {text: 'Zuletzt bearbeitet (Edited on)', value: 'edited_on', sortable: true, divider: true},
                //     {text: 'Auswertung (Evaluation)', value: 'evaluation', sortable: true, divider: true},
                // ],
            },

            actions: {
                async fetchItemList(ctx, storeDocItemId=null) {
                    // console.log('fetchItemList', storeDocItemId)
                    ctx.commit('updateLoading', true)
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    const page = ctx.state.options.page
                    const page_size = ctx.state.options.itemsPerPage
                    let order_by = ctx.state.options.sortBy[0]
                    if (ctx.state.options.sortDesc[0] == true) {
                        order_by = '-' + order_by
                    }
                    let url = baseUrl + "?page=" + page + "&page_size=" + page_size + "&id=" + storeDocItemId + "&order_by=" + order_by
                    if (ctx.state.searchTerm != null) {
                        url += '&search_term=' + ctx.state.searchTerm
                    }
                    if (storeDocItemId != null) {
                        url += '&id=' + storeDocItemId
                    }
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        console.log('Error fetchItemList:', res)
                        ctx.commit('updateLoading', false)
                        this._vm.$toast.error("Error:" + res.statusText + ', ' + res.status, {timeout: 5000})
                        const result = await res.json()
                        console.log('Error fetchItemList:', result)
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        return
                    }
                    const resJson = await res.json();
                    const totalRecords = resJson.count
                    const itemList = resJson.results

                    // console.log('fetchItemList', itemOrArrayId, itemList)
                    ctx.commit('updateItemList', itemList)
                    ctx.commit('updateTotalRecords', totalRecords)
                    ctx.commit('updateLoading', false)
                },
                async fetchRestoreItem(ctx, item) {
                    console.log('fetchRestoreItem', item)
                    ctx.commit('updateDeleteLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                    };
                    const res = await fetch(baseUrl + item.history_id + '/', requestParams);
                    if (!res.ok) {
                        console.log('Error fetchRestoreItem:', res)
                        ctx.commit('updateDeleteLoading', false)
                        this._vm.$toast.error("Error:" + res.statusText + ', ' + res.status, {timeout: 5000})
                        const result = await res.json()
                        console.log('Error fetchRestoreRow:', result)
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        return
                    }
                    ctx.commit('updateDeleteLoading', false)
                },
            },

            mutations: {
                updateField,
                updateItemList(state, itemList) {
                    state.itemList = itemList
                },
                updateTotalRecords(state, totalRecords) {
                    state.totalRecords = totalRecords
                },
                updateLoading(state, loading) {
                    state.loading = loading
                },
                updateDeleteLoading(state, restoreLoading) {
                    state.restoreLoading = restoreLoading
                },
            },

            getters: {
                getField,
                getItemList(state) {
                    return state.itemList
                },
                getTotalRecords(state) {
                    return state.totalRecords
                },
                getColumns(state) {
                    if (state.briefView) {
                        return state.columns.filter(row => row.brief === true)
                    }
                    else {
                        return state.columns
                    }
                },
            }
        }
    }
}

const baseUrl = '/api/store_file_history/'